import React from "react";
import style from "./RecentTransactionsnew.module.scss";
import cartIcon from "../../../../../assets/icons/cartIcon.svg";
import circleDownarrow from "../../../../../assets/icons/circleDownarrow.svg";
import Button from "../../../../common/Button/Button";
import { getTransactionDetailsDashboardAction } from "../../../../../features/user/userSlice";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../../routes";
import { formatPrice } from "../../../../../utils/utils";
import NoContent from "../../../../common/NoContent/NoContent";

const RecentTransactionsnew = () => {
  const [recentList, setRecentList] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [imgUrl, setImgUrl] = useState("");
  const transactions = [
    {
      id: 1,
      icon: cartIcon,
      title: "Bought Gold STBL",
      time: "2 hours ago",
      amount: "+2.5 GSTBL",
      price: "$4,885.80",
      status: "",
    },
    {
      id: 2,
      icon: circleDownarrow,
      title: "Deposit via Bank Transfer",
      time: "Yesterday",
      amount: "+$10,000.00",
      price: "Completed",
      status: "completed",
    },
    {
      id: 3,
      icon: cartIcon,
      title: "Bought Gold STBL",
      time: "2 hours ago",
      amount: "+2.5 GSTBL",
      price: "$4,885.80",
      status: "",
    },
    {
      id: 4,
      icon: circleDownarrow,
      title: "Deposit via Bank Transfer",
      time: "Yesterday",
      amount: "+$10,000.00",
      price: "Completed",
      status: "completed",
    },
  ];

  const getTransactions = async (data) => {
    try {
      const response = await dispatch(getTransactionDetailsDashboardAction());
      if (response?.status === 200) {
        setRecentList(response?.data?.data?.recentTransactions);
        setImgUrl(response?.data?.data?.imageUrl);
      }
    } catch (error) {
      console.log("Something went wrong:", error);
    }
  };

  useEffect(() => {
    getTransactions();
  }, []);

  return (
    <>
      <div className={style.transactioncard}>
        <div className={style.transactionheader}>
          <h4>Recent Transactions</h4>
          <Button
            variant="xtra_small"
            className={style.viewall}
            onClick={() =>
              navigate(ROUTES.TRANSACTIONS_COMPLETED, {
                state: { activeTab: "marketplace" },
              })
            }
          >
            View All
          </Button>
        </div>

        <div className={style.transactionlist}>
          {recentList?.length > 0 ? (
            recentList?.map((item) => (
              <div className={style.transactionitem} key={item.id}>
                <div className={style.transactionleft}>
                  <div className={style.icon}>
                    <img src={`${imgUrl}${item.image}`} alt="token-icon" />
                  </div>

                  <div>
                    <h6 className={style.title}>
                      {item.type === "SELL" ? "Sold" : "Bought"} {item.name}
                    </h6>

                    <p className={style.time}>
                      {new Date(item.created_at).toLocaleString()}
                    </p>
                  </div>
                </div>

                <div className={style.transactionright}>
                  <h6 className={style.amount}>
                    {item.type === "SELL" ? "-" : "+"}
                    {formatPrice(item.quantity)} {item.name}
                  </h6>

                  <p
                    className={`${style.price} ${item.status === "COMPLETED" ? style.completed : ""
                      }`}
                  >
                    ${formatPrice(item.price)}
                  </p>
                </div>
              </div>
            ))
          ) : (
            <NoContent
              content={"No recent transactions found."}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default RecentTransactionsnew;
